import React from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import useWindowDimensions from '../../Hooks/useWindowDimensions';
import { useLocation } from 'react-router-dom';

const WalkthroughProgressBar = (props) => {

  const totalNumOfQuestions = props?.totalNumOfQuestions;
  const currentSectionName = props?.currentSectionName;
  const currentProgress = props?.currentProgress;

  const { windowWidth } = useWindowDimensions();

  let location = useLocation()
  let percentageColor = '#578494';
  let activeColor = '#578494';

  let fromBeforeYouBegin = props?.fromBeforeYouBegin;
  let fromGetStarted = props?.fromGetStarted;
  let isWalkthroughStarted = props?.isWalkthroughStarted

  let adjustedProgress = currentProgress;

  if (fromGetStarted) {
    adjustedProgress += 1;
  } else if (fromBeforeYouBegin) {
    adjustedProgress += 0;
  }

 let progress = Math.min(100, Math.round((adjustedProgress / totalNumOfQuestions) * 100));

  if ( fromGetStarted == true && currentProgress == 2 ) progress = 100;

  console.log('Progress:', progress);
  console.log('walkthrough currentProgress:', currentProgress);
  console.log('activeStep-progressBar', props?.currentProgress)
  console.log('props?.isWalkthroughStarted', props?.isWalkthroughStarted)

  return (
    <div>
      <div className="progress-bar" style={{ maxWidth: windowWidth < 830 ? "75%" : "100%" }}>
        <div className="bar-section" style={{ width: location?.pathname?.includes('/walkthrough') ? "20%" : "100%", margin: location?.pathname?.includes('/walkthrough') ? "0 auto" : null }}>
        <p className="progress-percentage" style={{ width: `${progress}%`, color: percentageColor}}><span>{!location?.pathname?.includes('/walkthrough') ? progress : null }{!location?.pathname?.includes('/walkthrough') ? "%" : null }</span></p>
          <div className="bar"><LinearProgress className="custom-bar" variant="determinate" value={parseInt(progress)} /></div>
          <div className="sections" style={{ width: "100%", display: "flex", justifyContent: "space-evenly" }}>
            <p style={{
              color: location?.pathname?.includes('/walkthrough') ? "#29403F" : activeColor, textTransform: "uppercase", textAlign: "center",fontSize:"18px",fontWeight:"700", lineHeight: "110.00000000000001%", letterSpacing: 0
            }} className="section-name">{currentSectionName === "Starter" ? "STARTER/FLOW" : currentSectionName }</p>
          </div>
        </div>
      </div>
    </div>
  );
}
export default WalkthroughProgressBar;
